var filters = {
	selectors: { },
	counterOfActive: 0,

	init: function () {
		var self = this;

		self.toggleLevels();
		self.counting();
		self.openFiltr();

		//self.nouislider();

		jQuery( '.filters__moreLink' ).on( 'click', function( e ){
			e.preventDefault();
			jQuery( this ).parent().find( '[data-viewall]' ).toggleClass( 'viewall' );
		});
		
		jQuery('[data-clear-all]').on('click', function(e) {
			e.preventDefault();
		
			// Create a new URL object from the current window location
			let currentUrl = new URL(window.location.href);
		
			// Extract the origin (protocol + hostname + port) and pathname (path)
			let baseUrl = currentUrl.origin + currentUrl.pathname;
		
			// Check for start_date and end_date parameters
			let startDate = currentUrl.searchParams.get('start_date');
			let endDate = currentUrl.searchParams.get('end_date');
		
			// Create an array to store the parameters to be added back
			let paramsToAdd = [];
		
			if (startDate) { paramsToAdd.push(`start_date=${startDate}`); }
			if (endDate) { paramsToAdd.push(`end_date=${endDate}`); }
		
			// Append the parameters to the baseUrl if they exist
			if (paramsToAdd.length > 0) {
				baseUrl += '?' + paramsToAdd.join('&') + '#filtered-listing';
			}
		
			// Redirect to the updated URL
			window.location.href = baseUrl;
		});

		self.updateCounter();
	},

	updateCounter() {
		var self = this;

		self.counterOfActive = 0;
		jQuery( '.filters > div' ).each(function(){
			if( jQuery( this ).find( ':checkbox:checked' ).length > 0 ) {
				self.counterOfActive++;
			}
		});

		jQuery( '.js-openFilters[data-count]' ).attr( 'data-count', self.counterOfActive );
	},

	nouislider: function() {
		const html5Slider = document.getElementById('html5');

		const inputNumber = document.getElementById('input-number');

		const inputNumber2 = document.getElementById('input-number-2');

		noUiSlider.create(html5Slider, {
			start: [10, 30],
			connect: true,
			step: 1,
			range: {
				'min': -20,
				'max': 40
			},
			format: wNumb({
				decimals: 0
			})
		});

		html5Slider.noUiSlider.on('update', function (values, handle) {

			var value = values[handle];
		
			if (handle) {
				inputNumber2.value = value;
			} else {
				inputNumber.value = value;
			}
		});



		inputNumber.addEventListener('change', function () {
			html5Slider.noUiSlider.set([this.value, null]);
		});
		inputNumber2.addEventListener('change', function () {
			html5Slider.noUiSlider.set([null, this.value]);
		});
	},


	toggleLevels: function() {
		if( document.querySelectorAll( '.js-toggleLevels' ).length == 0) {
			return false;
		}

		document.querySelectorAll( '.js-toggleLevels' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {
				e.preventDefault();
				button.closest( ".js-levels").classList.toggle( 'active' );
			});
		});
	},

	counting: function() {
		if( document.querySelectorAll( '.js-levels' ).length == 0) {
			return false;
		}

		document.querySelectorAll( '.js-levels' ).forEach(function( levels, item ){
			const checkboxes = levels.querySelectorAll('[type="checkbox"]');
			const checkedCountLabel = levels.querySelector('div:first-of-type label');
			const specificCheckbox = levels.querySelector('div:first-of-type [type="checkbox"]');
		  
			checkboxes.forEach(function(checkbox) {
			  checkbox.addEventListener('change', function() {
				const checkedCount = levels.querySelectorAll('[type="checkbox"]:not(.js-countLevel ):checked').length;
				const checkedCountAll = levels.querySelectorAll('[type="checkbox"]:checked').length;
				
				checkedCountLabel.setAttribute('data-count', checkedCount);
				
				specificCheckbox.checked = checkedCountAll > 0;
			  });
			});
		});
	},

	openFiltr: function() {
		const self = this;

		if( jQuery( '#events_range' ) ) {
			self.rangePicker( '#events_range', 'event' );
		}
		
		if( jQuery( '#products_date_range' ) ) {
			self.rangePicker( '#products_date_range', 'product' );
		}

		if( document.querySelectorAll( '.js-openFilters' ).length == 0 ) {
			return false;
		}

		jQuery( '.js-openFilters' ).on( 'click', function( event ){
			event.preventDefault();
			self.openFiltersModal();
		});
	},

	rangePicker: function( target, post_type ) {
		const self = this;

		// Initialize the current date using moment.js
		self.currentDate = moment();

		// console.log( self.currentDate );

		// Initial dates
		let initialStartDate = self.currentDate;
		let initialEndDate 	 = self.currentDate.clone().add( 1, 'year' );
		const dateRange 	 = self.getDateFromUrlParams();

		if (dateRange) {
			// Use the dates from URL if valid
			initialStartDate = dateRange.startDate;
			initialEndDate = dateRange.endDate;
		}

		self.initializeDateRangePicker( target, initialStartDate, initialEndDate);

		// Event listener for apply.daterangepicker
		jQuery( target ).on( 'apply.daterangepicker', function(ev, picker) {
			// Format the start and end dates
			const formattedStartDate = self.formatDate(picker.startDate, pctVars.l18n.weekDays);
			const formattedEndDate = self.formatDate(picker.endDate, pctVars.l18n.weekDays) + ' ' + picker.endDate.format('YYYY');
	
			// Set the formatted date range to the input element
			jQuery( this ).val(`${formattedStartDate} – ${formattedEndDate}`);
			// console.log(`${formattedStartDate} – ${formattedEndDate}`);
	
			// Update the previous value to the new applied value
			jQuery( this ).attr('data-startdate', picker.startDate.format( 'YYYY-MM-DD' ) );
			jQuery( this ).attr('data-enddate', picker.endDate.format( 'YYYY-MM-DD' ) );
			jQuery( this ).attr('data-daycount', picker.endDate.diff(picker.startDate, 'days') + 1);

			// self.enableRangeArrows();
			self.applyDate( target );
		});
		
		// Event listener for apply.daterangepicker
		jQuery( target ).on( 'cancel.daterangepicker', function(ev, picker) {
			// Format the start and end dates
			// let formattedStartDate = self.formatDate(picker.startDate, pctVars.l18n.weekDays);
			// let formattedEndDate = self.formatDate(picker.endDate, pctVars.l18n.weekDays) + ' ' + picker.endDate.format('YYYY');
	
			// Set the formatted date range to the input element
			//jQuery( this ).val(`${formattedStartDate} – ${formattedEndDate}`);
			// console.log(`${formattedStartDate} – ${formattedEndDate}`);

			const now = moment();
			const nextYear = moment().add(1, 'year');
		
			picker.setStartDate(now);
			picker.setEndDate(nextYear);
		
			const formattedStartDate = self.formatDate(picker.startDate, pctVars.l18n.weekDays);
			const formattedEndDate = self.formatDate(picker.endDate, pctVars.l18n.weekDays) + ' ' + picker.endDate.format('YYYY');
		
			jQuery(this).val(`${formattedStartDate} – ${formattedEndDate}`);
	
			// Update the previous value to the new applied value
			jQuery( this ).attr('data-startdate', picker.startDate.format( 'YYYY-MM-DD' ) );
			jQuery( this ).attr('data-enddate', picker.endDate.format( 'YYYY-MM-DD' ) );
			jQuery( this ).attr('data-daycount', picker.endDate.diff(picker.startDate, 'days') + 1);
		});

		jQuery( '.listing-controls__date__delete' ).on('click', function() {
			self.initializeDateRangePicker( target, initialStartDate, initialEndDate);
			self.applyDate( target, false );
		});

		/* // Event listeners for custom arrows
		jQuery( '.listing-controls__date__pref' ).on('click', function() {
			const dayCount = parseInt(jQuery('#events_range').attr('data-daycount'), 10);
			self.updateDateRange(-dayCount);
		});
	
		jQuery( '.listing-controls__date__next' ).on('click', function() {
			const dayCount = parseInt(jQuery('#events_range').attr('data-daycount'), 10);
			self.updateDateRange(dayCount);
		}); */
	},

		getDateFromUrlParams: function() {
			const urlParams = new URLSearchParams(window.location.search);
			const startDateParam = urlParams.get('start_date');
			const endDateParam = urlParams.get('end_date');
			
			// Validate the dates using Moment.js
			const startDateValid = moment(startDateParam, 'YYYY-MM-DD', true).isValid();
			const endDateValid = moment(endDateParam, 'YYYY-MM-DD', true).isValid();
			
			if (startDateValid && endDateValid) {
				const startDate = moment(startDateParam);
				const endDate = moment(endDateParam);
				return { startDate, endDate };
			} else {
				return null;
			}
		},

		applyDate: function( target, add = true ) {
			const self = this;

			if( ! add ) {
				self.updateURL( { start_date: '', end_date: '' } );
				return false;
			}

			const rangeInput = jQuery( target );
			const startDate  = rangeInput.attr('data-startdate' );
			const endDate 	 = rangeInput.attr('data-enddate' );

			//self.updateURL( { start_date: startDate, end_date: endDate } );
		},

		updateURL: function(params) {
			const self = this;

			const url = new URL(window.location.href);
			const searchParams = new URLSearchParams(url.search);
		
			// Add or update start_date and end_date if they exist in params
			if (params.start_date != '' ) {
				searchParams.set('start_date', params.start_date);
			}  else {
				searchParams.delete('start_date');
			}
		
			if (params.end_date != '') {
				searchParams.set('end_date', params.end_date);
			} else {
				searchParams.delete('end_date');
			}
		
			// Update the URL without reloading the page
			url.search = searchParams.toString();

			// Convert the URL to a string
			let urlString = url.toString();

			// Check if the URL already has the '#filtered-listing' fragment
			if (!urlString.includes('#filtered-listing')) {
				// Append the '#filtered-listing' fragment if not already present
				urlString += '#filtered-listing';
			}

			window.location.href = urlString;
		},

		// Initialize the daterangepicker
		initializeDateRangePicker( target, startDate, endDate ) {
			const self = this;

			jQuery( target ).daterangepicker({
				'locale': {
					'format': 'DD. MM. YYYY',
					'separator': ' – ',
					'applyLabel': pctVars.l18n.apply,
					'cancelLabel': pctVars.l18n.cancel,
					'fromLabel': pctVars.l18n.from,
					'toLabel': pctVars.l18n.to,
					'customRangeLabel': 'Custom',
					'weekLabel': 'W',
					'daysOfWeek': pctVars.l18n.weekDays,
					'monthNames': pctVars.l18n.months,
					'firstDay': 1,
				},
				'opens': 'left',
				'startDate': startDate,
				'endDate': endDate,
				'minDate': self.currentDate,
			});

			// Set the initial value of the input element
			const formattedStartDate = self.formatDate(startDate, pctVars.l18n.weekDays);
			const formattedEndDate = self.formatDate(endDate, pctVars.l18n.weekDays) + ' ' + endDate.format('YYYY');
			jQuery( target ).val(`${formattedStartDate} – ${formattedEndDate}`);
			//console.log(`${formattedStartDate} – ${formattedEndDate}`);
	
			// Store the initial value to restore it if the selection is canceled
			jQuery( target ).attr( 'data-startdate', startDate.format( 'YYYY-MM-DD' ) );
			jQuery( target ).attr( 'data-enddate', endDate.format( 'YYYY-MM-DD' ) );
			jQuery( target ).attr( 'data-daycount', endDate.diff(startDate, 'days') + 1 );
		},

		// Function to update the date range
		/* updateDateRange: function(deltaDays) {
			const self = this;

			const startDate = moment(jQuery('#events_range').attr('data-startdate'));
			const endDate = moment(jQuery('#events_range').attr('data-enddate'));
			
			const newStartDate = startDate.add(deltaDays, 'days');
			const newEndDate = endDate.add(deltaDays, 'days');
	
			self.initializeDateRangePicker(newStartDate, newEndDate);
		}, */

	// Function to format the date
	formatDate: function (date, daysOfWeek) {
		return date.format('ddd DD. MM.').replace('Sun', daysOfWeek[0]).replace('Mon', daysOfWeek[1]).replace('Tue', daysOfWeek[2]).replace('Wed', daysOfWeek[3]).replace('Thu', daysOfWeek[4]).replace('Fri', daysOfWeek[5]).replace('Sat', daysOfWeek[6]);
	},

	/* enableRangeArrows: function() {
		self.enableRangeArrows( 'next' );
		self.enableRangeArrows( 'pref' );
	},

		enableRangeArrows: function( type ) {
			const self = this;

			jQuery( '.listing-controls__date__pref' ).removeAttr( 'disabled' );
		},
	
	disableRangeArrows: function() {
		jQuery( '.listing-controls__date__pref' ).removeAttr( 'disabled' );
		jQuery( '.listing-controls__date__next' ).removeAttr( 'disabled' );
	}, */

	openFiltersModal: function() {
		jQuery.fancybox.open({
			src  : '.filters-modal', // Selector to the modal content container
			type : 'inline', // Content type
			touch: false,
		});
	},

	
};

export { filters };